export default "__VITE_ASSET__yDPDT2K4__"